import {
  useCompositeStoreProps
} from "./EZ23JQKA.js";
import {
  useStore,
  useStoreProps
} from "./4LP74VAP.js";

// src/radio/radio-store.ts
import * as Core from "@ariakit/core/radio/radio-store";
function useRadioStoreProps(store, update, props) {
  store = useCompositeStoreProps(store, update, props);
  useStoreProps(store, props, "value", "setValue");
  return store;
}
function useRadioStore(props = {}) {
  const [store, update] = useStore(Core.createRadioStore, props);
  return useRadioStoreProps(store, update, props);
}

export {
  useRadioStoreProps,
  useRadioStore
};
